import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

export const ARCADE_PATH = "/arcade";
const ARCADE_GAME_PATH = "/arcade/:instanceId";
const ARCADE_COMPETITION_PATH = "/arcade/competitions/:competitionId";

/** Un même jeu peut être ouvert en freeplay et en compétition : la page de jeu porte l'instance. */
export const arcadeGamePath = (instanceId: string): string => `${ARCADE_PATH}/${instanceId}`;
export const arcadeCompetitionPath = (competitionId: string): string => `${ARCADE_PATH}/competitions/${competitionId}`;

const ArcadePage = lazyWithRetry(() =>
  import("@/features/arcade/pages/ArcadePage").then((m) => ({ default: m.ArcadePage })),
);
const ArcadeGamePage = lazyWithRetry(() =>
  import("@/features/arcade/pages/ArcadeGamePage").then((m) => ({ default: m.ArcadeGamePage })),
);
const ArcadeCompetitionPage = lazyWithRetry(() =>
  import("@/features/arcade/pages/ArcadeCompetitionPage").then((m) => ({ default: m.ArcadeCompetitionPage })),
);

const arcadeRoutes: RouteConfig[] = [
  {
    path: ARCADE_PATH,
    element: <ArcadePage />,
    isProtected: true,
    useMainLayout: true,
    mainWide: true,
    mainBackground: "muted",
  },
  {
    path: ARCADE_COMPETITION_PATH,
    element: <ArcadeCompetitionPage />,
    isProtected: true,
    useMainLayout: true,
    mainWide: true,
    mainBackground: "muted",
  },
  {
    path: ARCADE_GAME_PATH,
    element: <ArcadeGamePage />,
    isProtected: true,
    useMainLayout: true,
    mainBackground: "muted",
  },
];

export default arcadeRoutes;
